'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Form = require('../../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _index = require('../../Parser/index');

var _index2 = _interopRequireDefault(_index);

var _message = require('./styled/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThankYouMessage = function ThankYouMessage(_ref) {
  var message = _ref.message,
      formStore = _ref.formStore;
  return _react2.default.createElement(
    _message2.default,
    null,
    (0, _index2.default)((0, _index.template)(formStore, message))
  );
};
// styled


ThankYouMessage.propTypes = {
  message: _propTypes2.default.string.isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired
};

exports.default = (0, _mobxReact.inject)('formStore')(ThankYouMessage);